import Api from "../../services/Api";

function fetchSiteIdBySerial(serialNumber) {
  return Api.post("/service/evse_controller/api/v1/query/ev_charger", {
    is: { serialNumber, isRetired: false },
  });
}

export { fetchSiteIdBySerial };
